export enum PaymentMethod {
  canpay = 'canpay',
  cash = 'cash',
  /** @knipignore Knip has trouble detecting enum members not referred to explicitly. */
  credit = 'credit',
  /** @knipignore */
  debit = 'debit',
  moneris = 'moneris',
  /** @knipignore */
  payfirma = 'payfirma',
  /** @knipignore */
  paytender = 'paytender',
  square = 'square',
  stronghold = 'stronghold',
}
